<div class="soft-timeline-item">
  <div class="soft-timeline-rail" aria-hidden="true">
    <span class="soft-timeline-connector soft-timeline-connector-before"></span>
    <span class="soft-timeline-node-frame">
      @if (hasCustomNode()) {
        <ng-content select="soft-timeline-node, soft-ds-timeline-node" />
      } @else if (hasAvatar()) {
        <soft-ds-avatar
          class="soft-timeline-avatar"
          [src]="avatarSrc()"
          [alt]="avatarAlt()"
          [initials]="avatarInitials() ?? ''"
          size="md"
          style="
            width: var(--ds-timeline-node-size);
            height: var(--ds-timeline-node-size);
            font-size: var(--ds-timeline-avatar-font-size);
          "
        />
      } @else if (resolvedIcon(); as iconName) {
        <soft-ds-icon [name]="iconName" size="xs" color="current" />
      } @else if (nodeVariant() === 'number') {
        <soft-ds-number-badge [variant]="numberBadgeVariant()">
          {{ index() + 1 }}
        </soft-ds-number-badge>
      } @else {
        <span class="soft-timeline-dot"></span>
      }
    </span>
    <span class="soft-timeline-connector soft-timeline-connector-after"></span>
  </div>

  <div class="soft-timeline-content">
    <div class="soft-timeline-heading">
      <ng-content select="soft-timeline-title, soft-ds-timeline-title" />
    </div>
    @if (hasMetaRow()) {
      <div class="soft-timeline-meta-row">
        @if (hasIdentity()) {
          <span class="soft-timeline-identity">
            @if (identityName(); as name) {
              <span class="soft-timeline-identity-name ds-caption-medium">
                {{ name }}
              </span>
            }
          </span>
        }
        <ng-content select="soft-timeline-meta, soft-ds-timeline-meta" />
      </div>
    }
    <ng-content select="soft-timeline-description, soft-ds-timeline-description" />
    <div class="soft-timeline-body ds-body-2">
      <ng-content />
    </div>
  </div>
</div>
